export const iotControlData = {
    "Turn On": {
      allowedDevices: ["SWITCH", "PLUG", "LIGHT", "THERMOSTAT"]
    },
    "Turn Off": {
      allowedDevices: ["SWITCH", "PLUG", "LIGHT", "THERMOSTAT"]
    },
    "Brighter": {
      allowedDevices: ["SWITCH", "PLUG", "LIGHT"]
    },
    "Dimmer, less brighter": {
      allowedDevices: ["SWITCH", "PLUG", "LIGHT"]
    },
    "Warmer": {
      allowedDevices: ["LIGHT", "THERMOSTAT"]
    },
    "Softer": {
      allowedDevices: ["LIGHT"]
    },
    "Cooler": {
      allowedDevices: ["LIGHT", "THERMOSTAT"]
    },
    "Common colors": {
      allowedDevices: ["LIGHT"]
    },
    "Higher temperature": {
      allowedDevices: ["THERMOSTAT"]
    },
    "Lower temperature": {
      allowedDevices: ["THERMOSTAT"]
    },
    "Set to cool mode": {
      allowedDevices: ["THERMOSTAT"]
    },
    "Set to heat mode": {
      allowedDevices: ["THERMOSTAT"]
    },
    "Set to low speed": {
      allowedDevices: ["FAN", "AIR_PURIFIER"]
    },
    "Set to medium speed": {
      allowedDevices: ["FAN", "AIR_PURIFIER"]
    },
    "Set to high speed": {
      allowedDevices: ["FAN", "AIR_PURIFIER"]
    },
    "Set to auto": {
      allowedDevices: ["FAN", "AIR_PURIFIER"]
    },
    "Increase the fan speed": {
      allowedDevices: ["FAN", "AIR_PURIFIER"]
    },
    "Decrease the fan speed": {
      allowedDevices: ["FAN", "AIR_PURIFIER"]
    },
    "Open blinds/curtains/shades": {
      allowedDevices: ["WINDOW_COVERING"]
    },
    "Close blinds/curtains/shades": {
      allowedDevices: ["WINDOW_COVERING"]
    },
    "Stop moving": {
      allowedDevices: []
    },
    "Raise the shades halfway": {
      allowedDevices: ["WINDOW_COVERING"]
    },
    "What is the temperature?": {
      allowedDevices: ["THERMOSTAT", "AIR_PURIFIER"]
    }
  };